import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { getKiralikAracAdmin } from "../../features/admin3/admin3Slice";
import InputSelect from "../shared/input/new/InputSelect";
import InputText from "../shared/input/new/InputText";
import InputNewAracTypeSelect from "../shared/input/new/InputNewAracTypeSelect";
import { AdminAracEkleOptions } from "../../utils/adminAracEkleOptions";
import InputSelectCity from "../shared/input/new/InputSelectCity";
import AdminKiralikAracContainer from "../adminContainers/adminIlanlar/AdminKiralikAracContainer";
import Btn from "../shared/button/Btn";
import Pagination from "../shared/Pagination";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;
    .top-container{
      margin: 30px 0px;
    }
    .titles {
      width: 100%;
      margin-top: 30px;
      display: grid;
      grid-template-columns: repeat(14, 1fr); 
      padding-inline: 10px;
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-lg);
      text-align: center;
      color: ${({ theme }) => theme.mainTextColor};
    }
  }
`;

const titles = ["İlan Tarihi", "Araç Türü", "Kasa Tipi", "Çalışılmak İstenen İl", "Çalışılmak İstenen Güzergah", "Talep Edilen Yakıt Yüzdesi", "Talep Edilen Kira Bedeli", "İlan İçin Aranacak Telefon", "Kaydeden", "Kaydeden Telefon", "İlan Bitiş", "İlan Onay", "İlan Durumu", "Kiraya Verildi Mi?"]

const durumData = [
  {
    id:1,
    text:"Yayında",
    bool: true
  },
  {
    id:2,
    text:"Arşivde",
    bool: false
  }
]

const advertUserData = [
  {
    id: 0,
    text: "Tümü"
  },
  {
    id: 1,
    text: "İlanlarım"
  },
  {
    id: 2,
    text: "Diğer İlanlar"
  }
]

const onayData = [
  {
    id: 0,
    text: "Onay Bekliyor",
    bool: true
  },
  {
    id: 1,
    text: "Onaylandı",
    bool: true
  },
  {
    id: 2,
    text: "Reddedildi",
    bool: true
  }
]

const KiralikAraclarAdmin = () => {
  const { theme } = useSelector((state) => state.layout);
  const { adminKiralikAracList, adminKiralikAracCount } = useSelector((state) => state.admin3);
  const dispatch = useDispatch()
  const [aracTuru, setAracTuru] = useState("")
  const [calisilacakIl, setCalisilacakIl] = useState("")
  const [advertisementCompany, setAdvertisementCompany] = useState("")
  const [ilanDurumu, setIlanDurumu] = useState(null)
  const [onayDurum, setOnayDurum] = useState(null)

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const totalPages = Math.ceil(adminKiralikAracCount / itemsPerPage);

  useEffect(() => {
    dispatch(getKiralikAracAdmin({workCity: calisilacakIl?.value, vehicleType: aracTuru?.name, advertisementCompany: advertisementCompany, isApproved: onayDurum?.id, isActive: ilanDurumu?.bool, page: currentPage }))
  }, [ilanDurumu, calisilacakIl, aracTuru, onayDurum, advertisementCompany, currentPage])

  const handleClear = () => {
    setCalisilacakIl("")
    setAdvertisementCompany("")
    setOnayDurum(null)
    setIlanDurumu(null)
    setAracTuru("")
  }
  
  return (
    <Container theme={theme}>
      <div className="container">
        <div className="top-container">
            <InputNewAracTypeSelect data={aracTuru} setData={setAracTuru} name={"aracTuru"} labelText={"Araç Türü"} initialOptions={AdminAracEkleOptions} />
            <InputSelectCity data={calisilacakIl?.value} setData={setCalisilacakIl} name={"calisilacakIl"} labelText={"Çalışılacak İl"} />
            <InputText data={advertisementCompany} setData={(e) => setAdvertisementCompany(e.target.value)} name={"advertisementCompany"} labelText={"Firma"} />
            <InputSelect data={ilanDurumu?.text} setData={setIlanDurumu} initialOptions={durumData} name={"ilanDurumu"} labelText={"İlan Durumu"} />
            <InputSelect data={onayDurum?.text} setData={setOnayDurum} initialOptions={onayData} name={"onayDurum"} labelText={"Onay Durumu"} />
            <Btn color="#E85446" bgColor="transparent" width={"150px"} handleClick={handleClear}>Temizle</Btn>
        </div>

        <div className="titles">
          {titles.map((item) => (
              <p>{item}</p>
          ))}
        </div>

        {adminKiralikAracList.map((item) => (
          <AdminKiralikAracContainer data={item} />
        ))}
        {(adminKiralikAracList && adminKiralikAracList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </Container>
  );
};

export default KiralikAraclarAdmin;
